import { Outlet } from 'react-router-dom';
import FirmHeader from './firmHeader';

export default function MainFirm () {
    return (
        <div className="main-body relative">
            <FirmHeader />
            <Outlet />
        </div>
    )
}